module.exports = __webpack_public_path__ + "static/media/tiponis-wilds.fba7ad50.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/tiponis-wilds.png
// module id = 1369
// module chunks = 1